module.exports = __webpack_public_path__ + "img/2.5bae099c.jpg";